export type IssueMapTileLang = 'en' | 'de' | 'fr';

export const ISSUE_MAP_TILE_LANGS: IssueMapTileLang[] = ['en', 'de', 'fr'];

export const ISSUE_MAP_TILE_LANG_I18N: Record<IssueMapTileLang, string> = {
  en: 'targetedMarketing.issueMapLangEn',
  de: 'targetedMarketing.issueMapLangDe',
  fr: 'targetedMarketing.issueMapLangFr',
};

const FR_SUBDOMAINS = ['a', 'b', 'c'] as const;

export function resolveIssueMapTileLang(locale: string): IssueMapTileLang {
  const short = locale.split(/[_-]/)[0].toLowerCase();
  if (short === 'de' || short === 'fr') {
    return short;
  }
  return 'en';
}

export function issueMapTileUrl(
  lang: IssueMapTileLang,
  x: number,
  y: number,
  z: number,
): string {
  if (lang === 'de') {
    return `https://tile.openstreetmap.de/${z}/${x}/${y}.png`;
  }
  if (lang === 'fr') {
    const host = FR_SUBDOMAINS[Math.abs(x + y) % FR_SUBDOMAINS.length];
    return `https://${host}.tile.openstreetmap.fr/osmfr/${z}/${x}/${y}.png`;
  }
  return `https://tile.openstreetmap.org/${z}/${x}/${y}.png`;
}

export function issueMapTileProvider(
  lang: IssueMapTileLang,
): (x: number, y: number, z: number) => string {
  return (x, y, z) => issueMapTileUrl(lang, x, y, z);
}
